import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 0L8 4L4 8L0 4L4 0Z",
		fill: "currentColor"
	})
});
export default SvgDiamond;
